import { format, parseISO } from 'date-fns';
import { SiAdblock } from 'react-icons/si';
import React from 'react';
import { es } from 'date-fns/locale';
import Progress from './progress';

const ReservationCard = ({ reservation, onPenalize }) => {
   const { tower, floor, amenity, user, code, schedule, penalty, metric } =
      reservation;

   return (
      <div className="bg-white p-4 rounded-2xl shadow-md h-auto space-y-3">
         {/* Info Principal */}
         <div className="grid grid-cols-2 gap-4">
            <div className="space-y-1">
               <Info label="Torre" value={tower?.name} />
               <Info label="Piso" value={floor?.name} />
               <Info label="Amenidad" value={amenity?.name} />
            </div>
            <div className="space-y-1">
               <Info label="Usuario" value={user?.fullName} />
               <Info label="Clave" value={code} />
               <Info
                  label="Fecha"
                  value={`${format(
                     parseISO(schedule.start),
                     'EEE dd LLL - HH:mm',
                     { locale: es },
                  )} - ${format(parseISO(schedule.end), 'HH:mm')}`}
                  small
               />
               {penalty > 0 && (
                  <span className="text-xs text-red-500 font-semibold">
                     Penalizado: {penalty}
                  </span>
               )}
            </div>
         </div>

         {/* Barra de progreso + acción */}
         <div className="flex items-center justify-between">
            <div className="flex-1 pr-4">
               <Progress
                  width="w-full"
                  value={Math.min(metric.progress, 100)}
                  color={
                     metric.progress >= 100
                        ? 'red'
                        : metric.progress > 90
                        ? 'yellow'
                        : 'green'
                  }
               />
            </div>
            <button
               title="Penalizar usuario"
               className="flex items-center justify-center rounded-full bg-red-500 p-2 text-white hover:bg-red-600 active:bg-red-700 transition"
               onClick={() => onPenalize(reservation._id, user._id)}>
               <SiAdblock size={20} />
            </button>
         </div>
      </div>
   );
};

// Componente auxiliar para reducir repetición
const Info = ({ label, value, small = false }) => (
   <div className="flex flex-col">
      <span className={`text-xs ${small ? 'text-gray-400' : 'text-gray-500'}`}>
         {label}
      </span>
      <strong
         className={`text-sm ${small ? 'text-gray-600' : 'text-gray-800'}`}>
         {value}
      </strong>
   </div>
);

export default ReservationCard;
